module.exports = __webpack_public_path__ + "img/bg-principle.2694ddac.jpg";